module.exports = __webpack_public_path__ + "img/undraw_upload_87y9.e8d5506e.svg";